import { getRoutes } from './get-routes';
/**
 * Gets route by identifier, all levels routes.
 * @param identifier - Identifier of the route.
 * @param routes - (Optional) Specific routes where the search will be performed. If this parameter is not passed, the search is performed on all application routes.
 * @returns Route Object
 */
export function getRouteByIdentifier(identifier, routes) {
    routes = routes !== null && routes !== void 0 ? routes : getRoutes();
    for (const route of routes || []) {
        if (route.name === identifier) {
            return route;
        }
        if (route.children) {
            const foundRoute = getRouteByIdentifier(identifier, route.children);
            if (foundRoute) {
                return foundRoute;
            }
        }
    }
    return null;
}
